import React from 'react';
import teamData from "../../data/Team/team-data.json";
import HeadingSection from '../HeadingSection/HeadingSection';
import Icofont from 'react-icofont';

const Team = () => (
    <section className="white-bg">
    <div className="container" id='section3'>
      <div className="row">
        <HeadingSection title="Наша команда" tagline="Експерти, яким довіряють!"/>
      </div>
      <p style={{color:'black'}}>За кожною успішною співпрацею з City Brokers стоїть команда справжніх професіоналів страхової галузі.</p>
      <p style={{color:'black'}}>Це не просто група фахівців, а справжні майстри своєї справи, які накопичили понад 20 років практичного досвіду в найвпливовіших страхових структурах, як в Україні, так і за її межами.</p>
      <p style={{color:'black'}}>Наша сила – у багатогранності: поряд з досвідченими страховими фахівцями, до нашої команди входять кваліфіковані адвокати та фахівці з врегулювання страхових випадків, які володіють глибокими знаннями як українського, так і міжнародного ринку.</p>
      <p style={{color:'black'}}>Кожен член нашої команди присвячений одній меті – забезпечити вам надійний захист та спокій. З нами ви можете бути впевнені: ваші інтереси в надійних руках.</p>
      <div className="row mt-50">
        {teamData.map((member) => (
          <div style={{height:'500px'}} className="col-md-3 col-sm-6 our-team city-team" key={member.id}>
            <div className="member text-center">
              <div style={{maxHeight:'336px'}} className="team-member-container">
                <img
                  src={require("../../assets/images/" + member.image)}
                  className="img-responsive"
                  alt="team-01"
                />
                <div className="member-caption">
                  <div className="member-description text-center">
                    <div className="member-description-wrap">
                      <ul className="member-icons">
                        {member.social.map((item) => {
                          return (
                            <li className="social-icon" key={item.id}>
                              <a href={item.link}>
                                <Icofont icon={item.icon} />
                              </a>
                            </li>
                          );
                        })}
                        <div style={{color:'white'}}>
                          {member.desc}
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <h4 className="member-title">{member.name}</h4>
              <p className="member-subtitle">{member.role}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>

);

export default Team;